import sizes from "src/config/sizes";

export default function getSizeData(size: string | null) {
  const sizeData = sizes.find((data: any) => data.name === size);

  if (sizeData) {
    return sizeData;
  } else {
    return null;
  }
}
